import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import pointsMailHomePage from './views/points-mail-home-page'
import commodityClass from './views/commodity-class/commodity-class'
import commodityList from './views/commodity-list/commodity-list'


export default [
  {
    path: RoutePathConstants.POINTS_MAIL_HOME_PAGE,
    name: 'pointsMailHomePage',
    component: pointsMailHomePage
  },
  {
    path: RoutePathConstants.COMMODITY_CLASS,
    name: 'commodityClass',
    component: commodityClass
  },
  {
    path: RoutePathConstants.COMMODITY_LIST,
    name: 'commodityList',
    component: commodityList
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page/routers.js